import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('payments', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getBanks: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('banks', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getBeneficiaries: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('beneficiaries', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getCurrencies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('currencies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`banks/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
